const translations = {
  title: {
    _: 'Cover Type',
    'zh-hk': '保障類型',
  },
  options: {
    _: {
      SINGLE_PLAN: 'Single-Trip',
      ANNUAL_PLAN: 'Annual',
    },
    'zh-hk': {
      SINGLE_PLAN: '單次計劃',
      ANNUAL_PLAN: '全年旅程',
    },
  },
  optionsMobile: {
    _: {
      SINGLE_PLAN: 'Single-Trip',
      ANNUAL_PLAN: 'Annual Multi-trip',
    },
    'zh-hk': {
      SINGLE_PLAN: '單次計劃',
      ANNUAL_PLAN: '全年旅程',
    },
  },
  coverageTypeTooltip: {
    _: {
      SINGLE_PLAN: 'Covers one round trip back to Singapore',
      ANNUAL_PLAN:
        'Covers multiple round trips back to Singapore over a 12-month period from the coverage start date',
    },
    'en-hk': {
      SINGLE_PLAN: 'Covers one round trip back to Hong Kong',
      ANNUAL_PLAN:
        'Covers multiple round trips back to Hong Kong over a 12-month period from the coverage start date',
    },
    'zh-hk': {
      SINGLE_PLAN: '涵蓋一次往返香港的單程旅行',
      ANNUAL_PLAN: '涵蓋多次往返香港的旅行，覆蓋期為從保障開始日期起計的12個月',
    },
  },
};

export default translations;
